export const MODULE_NAME = "svr";
export const MODULE_UI_NAME = "SVR";